const se = {
  launchKicker: "Dieđiheapmi ovdal álggaheami",
  launchTitle: "Olles áppa almmuhuvvo ovdal guovvamánu 1. beaivvi 2027.",
  launchBody: "Dál mii geahččalit áppa ja loahpahit guoibmesoahpamušaid. Dál lea áigi fitnodagaide, sponsoraide ja suohkaniidda dieđihit — ja oažžut 50 % vuolideami álggahanguoibmin.",
  launchCta: "Dieđit dál",
  testApp: "Geahččal geahččalanáppa",
  bandKicker: "Fitnodagaide",
  bandTitle: "Lasit iežat stáluid — 50 % vuolideapmi álggahanguimmiide.",
  bandBody: "Hotealat, kaféat, sávnnat, gávppit ja suohkanat sáhttet dieđihit dál ja leat stálut gearggusin go áppa almmuhuvvo.",
  bandCta: "Dieđit guoibmin",
  kicker: "Dieđiheapmi",
  title: "Bija iežat stáluid kártii.",
  lead: "Muital geas don leat, vállje páhka ja luoitte stáluid kártii. Don máksát Vippsain, ja mii ráhkadit stáluid gearggusin álggaheapmái.",
  role: "Gii don leat?",
  rolePh: "Vállje …",
  roles: { homeowner: "Viesoamasteaddji dahje priváhta guossoheaddji", municipality: "Suohkan, guovlu dahje mátkeealáhussearvi", sponsor: "Sponsor", other: "Eará" },
  firstName: "Ovdanamma",
  lastName: "Goargu",
  company: "Fitnodat dahje organisašuvdna",
  optional: "eaktodáhtolaš",
  email: "E-poasta",
  phone: "Telefovdna",
  website: "Neahttasiidu",
  package: "Páhkka",
  mapTitle: "Gosa háliidat stáluid?",
  mapHint: "Oza iežat čujuhusa, ja deaddil kártta luoitit stálu. Geasut nálu sirdit dan.",
  search: "Oza čujuhusa dahje báikki Norggas",
  searchBtn: "Oza",
  noResults: "Ii gávdnon báiki. Geahččal eará ohcama.",
  placed: "{n} / {max} stálu bidjojuvvon",
  full: "Buot stálut leat bidjojuvvon — sihko ovtta sirdit dan, dahje vállje stuorát páhka.",
  noPackage: "Vállje vuos páhka, de oainnát galle stálu sáhtát bidjat.",
  outside: "Stálut sáhttet bidjot dušše Norgii.",
  pin: "Stállu {n}",
  remove: "Sihko",
  message: "Leago juoga maid mii galgat diehtit?",
  messagePh: "Rabasáiggit, stáluideat, gažaldagat …",
  consent: "Mun dohkkehan ahte Trollfossjakten vurke dáid dieđuid gieđahallat mu dieđiheami. Geahča {privacy}.",
  submit: "Dieđit ja joatkke máksimii",
  sending: "Sádde …",
  summary: "Du diŋgojupmi",
  pickPackage: "Vállje páhka oaidnit hatti.",
  payNote: "Don máksát Vippsain dieđiheami maŋŋá. Álggahanhaddi: 50 % vuolideapmi vuosttaš jagi.",
  errors: {
    phone: "Čális gustovaš telefonnummira (logut, +, gaskkat).",
    required: "Deavdde buot bákkolaš gentiid.",
    email: "Čális gustovaš e-poastačujuhusa.",
    pins: "Bija unnimusat ovtta stálu kártii.",
    consent: "Dohkket movt mii vurket du dieđuid.",
    tooMany: "Menddo ollu dieđiheamit dán ovttadagas. Geahččal maŋŋelis.",
    generic: "Juoga manai boastut. Geahččal ođđasit.",
  },
  doneKicker: "Giitu!",
  doneTitle: "Don leat dieđihan, {name}.",
  doneBody: "Du diŋgonnummir lea {ref}. Mii leat sádden máŋgosa čujuhussii {email}. Mávse Vippsain sihkkarastit álggahanhatti.",
  doneBodyNoMail: "Du diŋgonnummir lea {ref}. Vurke dan — mávse Vippsain sihkkarastit álggahanhatti.",
  another: "Dieđit ođđa báikki",
  payTitle: "Mávse Vippsain",
  number: "Vipps-nummir",
  amount: "Supmi",
  ref: "Diŋgonnummir",
  copy: "Máŋge",
  copied: "Máŋgejuvvon",
  exVat: "Haddi árvolasseváldda haga",
  vat: "Árvolasseváldu 25 %",
  total: "Máksojuvvo",
  steps: ["Raba Vipps ja vállje sáddet ruđa", "Čális nummira {number}", "Čális supmi {amount} kr", "Čális diŋgonnummira {ref} dieđáhussii"],
  invoice: "Háliidatgo baicca fakturá? Vástit duođaštusa e-poastii, de mii sáddet.",
  host: { name: "Guossoheaddjibáiki", for: "Kafea, dállu, hytta, B&B, sávdni dahje gávpi mii váldá vuostá stálubivdiid ja Stálukruvnnuid", free: "Nuvttá" },
  mapTitleHost: "Gos lea du báiki — dahje gos plánet rahpat?",
  mapHintHost: "Oza du čujuhusa, ja deaddil kártta bidjat nállu. Gease dan sirdit dan.",
  placePin: "Du báiki",
  placedHost: "{n} / 1 báiki merkejuvvon",
  fullHost: "Du báiki lea merkejuvvon — gease nállu sirdit dan, dahje sihko dan vuos.",
  placeTitle: "Du báiki",
  placeBody: "Muital stálubivdiide maid don fálat, ja merke buot maid dus lea.",
  offer: "Maid don fálat?",
  offerPh: "omd. kaffe ja vafelat, sávdni, latnja idjii",
  amenitiesTitle: "Mii dus lea? Merke buot mii heive",
  amenities: { coffee: "Kaffe", tea: "Deadja", snacks: "Bálkkáš", restaurant: "Restoráŋŋa", conversations: "Ságastallamat", phone_charging: "Telefovnna luđen", bike_charging: "Elsykkela luđen", car_charging: "Elbiila luđen", shower: "Dušša", room: "Latnja", sauna: "Sávdni", bnb: "Bed & breakfast", hotel: "Hotealla", camping: "Leairabáiki", parking: "Parkeren", toilet: "Hivsset", wifi: "Wifi" },
  hostNote: "Lea nuvttá leat guossoheaddji — ii mákso iige dieđihanmáksu. Mii dárkkistit dieđuid ja bidjat du báikki kártii.",
  submitHost: "Registrere guossoheaddjin",
  offerError: "Muital midjiide maid don fálat.",
  hostDoneTitle: "Don leat registrerejuvvon guossoheaddjin, {name}.",
  hostDoneBody: "Du referánsa lea {ref}. Mii leat sádden kopiija {email}. Mii dárkkistit dieđuid ja bidjat du báikki kártii.",
  hostDoneBodyNoMail: "Du referánsa lea {ref}. Vurke dan — mii dárkkistit dieđuid ja bidjat du báikki kártii.",
  hostNextTitle: "Mii dáhpáhuvvá dál",
  hostNext: ["Viečča áppa ja čálit sisa seamma e-poasttain.", "Mana Profiila → Šatta guossoheaddjin álgit váldit vuostá Stálukruvnnuid.", "Skánne guossi máksin-QR — áppa rehkenastá dan mii báhcá máksit."],
  hostGetApp: "Viečča áppa",
};

export default se;
